import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../utils/axios-auth';
const initialState = {
    activities: [],
    status: 'idle',
    error: null
};
export const fetchTutorRecentActivity = createAsyncThunk('tutorActivity/fetchRecent', async (tutorId, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.get(`/tutors/${tutorId}/activity`, {
            params: { limit: 10 }
        });
        if (!response.data?.success) {
            return rejectWithValue(response.data?.message || 'Failed to fetch activity');
        }
        return response.data.data || [];
    }
    catch (error) {
        return rejectWithValue(error.response?.data?.message || error.message || 'Failed to fetch activity');
    }
});
const tutorActivitySlice = createSlice({
    name: 'tutorActivity',
    initialState,
    reducers: {
        clearTutorActivity: (state) => {
            state.activities = [];
            state.status = 'idle';
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchTutorRecentActivity.pending, (state) => {
            state.status = 'loading';
            state.error = null;
        })
            .addCase(fetchTutorRecentActivity.fulfilled, (state, action) => {
            state.status = 'succeeded';
            state.activities = action.payload;
            state.error = null;
        })
            .addCase(fetchTutorRecentActivity.rejected, (state, action) => {
            state.status = 'failed';
            state.error = action.payload || 'Failed to fetch activity';
        });
    }
});
export const { clearTutorActivity } = tutorActivitySlice.actions;
export const selectTutorActivities = (state) => state.tutorActivity.activities;
export const selectTutorActivityStatus = (state) => state.tutorActivity.status;
export const selectTutorActivityError = (state) => state.tutorActivity.error;
export default tutorActivitySlice.reducer;
